import React from 'react'
import { useSelector } from 'react-redux'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'

import { getIncludedItemsCount } from '../../../helpers'

const Suppliers = () => {
  const {
    criteria: {
      suppliers: { includeOrExclude, selectedItems }
    },
    data: {
      suppliers: { items: allSuppliers }
    }
  } = useSelector(state => state)

  const count = getIncludedItemsCount(
    includeOrExclude,
    allSuppliers.length,
    selectedItems.length
  )

  return (
    <ListItem dense disableGutters>
      <ListItemText>Suppliers:</ListItemText>
      <ListItemSecondaryAction>
        {`${count.toLocaleString()} / ${allSuppliers.length} included`}
      </ListItemSecondaryAction>
    </ListItem>
  )
}

export default Suppliers
